/**
 * Брейкпоинты в одном месте. Раньше `@media (max-width: 768px)` был
 * скопирован ~40 раз — теперь это `${media.md}`.
 */
export const breakpoints = {
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1280,
};

export const media = {
  sm: `@media (max-width: ${breakpoints.sm}px)`,
  md: `@media (max-width: ${breakpoints.md}px)`,
  lg: `@media (max-width: ${breakpoints.lg}px)`,
  xl: `@media (max-width: ${breakpoints.xl}px)`,

  /** Десктоп и выше — для «показать только на большом экране». */
  fromMd: `@media (min-width: ${breakpoints.md + 1}px)`,
};

export default media;
